import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { withGuestSearch } from "data/guestPortalDefaults";
import { useGuestSession } from "contexts/GuestSessionContext";
import GuestIcon from "./GuestIcon";
import { LUXURY } from "data/guestLuxuryTheme";

const ServicePageLayout = ({ title, subtitle, illustration, children }) => {
  const navigate = useNavigate();
  const { guestSearch } = useGuestSession();

  return (
    <Box sx={{ px: 2, pt: 2.4, pb: 2, maxWidth: LUXURY.maxWidth, mx: "auto" }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.1, mb: 2.2 }}>
        <IconButton
          onClick={() => navigate(withGuestSearch("/guest", guestSearch))}
          sx={{
            bgcolor: LUXURY.cardSoft,
            width: 40,
            height: 40,
            mt: 0.15,
            flexShrink: 0,
            border: `1px solid ${LUXURY.cardBorder}`,
            color: LUXURY.gold,
            boxShadow: "0 6px 14px rgba(0,0,0,0.2)",
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: LUXURY.displayFont,
              fontWeight: 600,
              fontSize: "1.38rem",
              color: LUXURY.ink,
              letterSpacing: "0.01em",
              lineHeight: 1.2,
              wordBreak: "break-word",
            }}
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography sx={{ mt: 0.35, color: LUXURY.muted, fontSize: "0.82rem", lineHeight: 1.45, wordBreak: "break-word" }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {illustration ? (
          <GuestIcon name={illustration} size={46} />
        ) : null}
      </Box>
      {children}
    </Box>
  );
};

export default ServicePageLayout;
